import React from "react";
const CheckMark = ({ color1, color2, style }) => {
    return (React.createElement("svg", { className: style, width: "559", height: "247", viewBox: "0 0 559 247", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { opacity: "0.2", d: "M0 186C0 186 77.5 240 252 169C426.5 98 559 0.00109863 559 0.00109863V247H0V186Z", fill: color1 }),
        React.createElement("path", { d: "M559 0C559 0 205.023 235.915 0 133.515V216.68C214.085 267.031 559 0 559 0Z", fill: color2 })));
};
export default CheckMark;
